import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Routes from './Routes';

export default class App extends React.Component {

    constructor(props: {}) {
        super(props);
    }

    render() {
        return (
            <BrowserRouter>
                <Routes />
            </BrowserRouter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app.tsx